import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IpState {
  [key: string]: any;
}

const initialState: IpState = {};

const ipSlice = createSlice({
  name: "ip",
  initialState,
  reducers: {
    printerIp(state, action: PayloadAction<any>) {
      return { ...state, ...action.payload };
    },
    ipReset() {
      return initialState;
    },
  },
});

export const { printerIp, ipReset } = ipSlice.actions;
export default ipSlice.reducer;